/* ==========================================================================
   DOLVAK · ürün sayfası hareket katmanı
   Geri sayım, stok çubuğu ve yapışkan satın alma barı.
   Tek bir global tikleyici kullanır; Dawn varyant değişiminde bölümü yeniden
   render ettiğinde (innerHTML ile gelen script çalışmaz) sayaç ölmesin diye.
   ========================================================================== */
(function () {
  'use strict';

  // Yorum bölümü ürün dışındaki şablonlarda da kullanılabildiği için bu dosya
  // hem theme.liquid'den hem de bölümün kendisinden çağrılabiliyor. İki kez
  // çalışırsa sayaç iki tikleyici, ışık kutusu iki dinleyici kurardı.
  if (window.__dvPdpReady) return;
  window.__dvPdpReady = true;

  var TR_OFFSET_MS = 180 * 60000; // Türkiye UTC+3 · yaz saati uygulaması yok
  var DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  /* Türkiye saatini tarayıcının saat diliminden bağımsız üretir.
     Dönen Date'i getUTC* ile okuyun: UTC alanları İstanbul saatini gösterir. */
  function istNow() {
    return new Date(Date.now() + TR_OFFSET_MS);
  }

  function fmt(ms) {
    if (ms < 0) ms = 0;
    var t = Math.floor(ms / 1000);
    var d = Math.floor(t / 86400);
    var h = Math.floor((t % 86400) / 3600);
    var m = Math.floor((t % 3600) / 60);
    var s = t % 60;
    if (d > 0) return d + 'g ' + pad(h) + ':' + pad(m) + ':' + pad(s);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  /* ---------- 1. Geri sayım ---------------------------------------------- */

  function shipsOn(day, sat, sun) {
    if (day === 6) return sat;
    if (day === 0) return sun;
    return true;
  }

  // Bir sonraki kargo kesim saatine kalan süre
  function cutoffLeft(el) {
    var hour = parseInt(el.getAttribute('data-hour'), 10);
    if (isNaN(hour)) hour = 16;
    var minute = parseInt(el.getAttribute('data-minute'), 10) || 0;
    var sat = el.getAttribute('data-sat') === 'true';
    var sun = el.getAttribute('data-sun') === 'true';

    var now = istNow();
    var base = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());

    for (var add = 0; add <= 8; add++) {
      var t = base + add * 86400000 + hour * 3600000 + minute * 60000;
      if (t <= now.getTime()) continue;
      var day = new Date(t).getUTCDay();
      if (!shipsOn(day, sat, sun)) continue;
      return { ms: t - now.getTime(), days: add, day: day };
    }
    return null;
  }

  // Ziyaretçiye özel sabit süreli teklif; sekme boyunca hatırlanır
  function fixedLeft(el) {
    var mins = parseFloat(el.getAttribute('data-minutes'));
    if (!mins || mins <= 0) mins = 20;
    var loop = el.getAttribute('data-loop') === 'true';
    var key = 'dv-offer:' + (el.getAttribute('data-key') || 'p');
    var now = Date.now();
    var end = 0;

    try {
      end = parseInt(window.sessionStorage.getItem(key), 10) || 0;
    } catch (e) {
      /* gizli sekmede sessionStorage kapalı olabilir */
    }

    if (!end || end <= now) {
      if (end && !loop) return { ms: 0, expired: true };
      end = now + mins * 60000;
      try {
        window.sessionStorage.setItem(key, String(end));
      } catch (e) {}
    }
    return { ms: end - now, expired: false };
  }

  function paintCountdown(el) {
    var clock = el.querySelector('[data-dv-clock]');
    if (!clock) return;
    var label = el.querySelector('[data-dv-label]');
    var res;
    var text;

    if (el.getAttribute('data-mode') === 'fixed') {
      res = fixedLeft(el);
      text = el.getAttribute('data-prefix') || '';
      if (res.expired) {
        text = el.getAttribute('data-closed') || text;
        el.classList.add('dv-count--closed');
      }
    } else {
      res = cutoffLeft(el);
      if (!res) {
        el.hidden = true;
        return;
      }
      var word = res.days === 0 ? 'Bugün' : res.days === 1 ? 'Yarın' : DAYS[res.day];
      text = (el.getAttribute('data-prefix') || '[gun] kargoya son').replace('[gun]', word);
      el.classList.toggle('dv-count--closed', res.days > 0);
    }

    if (label && label.textContent !== text) label.textContent = text;
    var out = fmt(res.ms);
    if (clock.textContent !== out) clock.textContent = out;
    el.classList.toggle('dv-count--soon', res.ms > 0 && res.ms <= 300000);
  }

  /* ---------- 2. Stok çubuğu --------------------------------------------- */

  function paintBars() {
    var bars = document.querySelectorAll('[data-dv-bar]:not([data-dv-filled])');
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i];
      var box = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (box.top > vh || box.bottom < 0) continue; // henüz görünmedi
      el.setAttribute('data-dv-filled', '1');
      (function (node) {
        window.requestAnimationFrame(function () {
          node.style.width = (parseFloat(node.getAttribute('data-pct')) || 0) + '%';
        });
      })(el);
    }
  }

  /* ---------- 3. Tek global tikleyici ------------------------------------ */

  function tick() {
    var nodes = document.querySelectorAll('[data-dv-countdown]');
    for (var i = 0; i < nodes.length; i++) paintCountdown(nodes[i]);
    paintBars();
  }

  /* ---------- 4. Yapışkan satın alma barı -------------------------------- */

  function stripIds(node) {
    if (node.removeAttribute) node.removeAttribute('id');
    var kids = node.querySelectorAll ? node.querySelectorAll('[id]') : [];
    for (var i = 0; i < kids.length; i++) kids[i].removeAttribute('id');
    return node;
  }

  function initSticky() {
    var bar = document.querySelector('[data-dv-sticky]');
    if (!bar) return;

    var info = document.querySelector('.product__info-container');
    if (!info) {
      bar.remove();
      return;
    }

    var holder = bar.querySelector('[data-dv-sticky-price]');
    var btn = bar.querySelector('[data-dv-sticky-btn]');
    var btnLabel = bar.querySelector('[data-dv-sticky-label]');
    var codBtn = bar.querySelector('[data-dv-sticky-cod]');
    var buyLabel = bar.getAttribute('data-buy-label') || 'Sepete Ekle';
    var soldLabel = bar.getAttribute('data-sold-label') || 'Tükendi';

    var priceWrap = info.querySelector('[id^="price-"]');
    var srcBtn = info.querySelector('[name="add"]');

    function syncPrice() {
      if (!holder) return;
      var src = priceWrap ? priceWrap.querySelector('.price') : null;
      if (!src) return;
      holder.innerHTML = '';
      holder.appendChild(stripIds(src.cloneNode(true)));
    }

    function syncState() {
      srcBtn = info.querySelector('[name="add"]') || srcBtn;
      if (!btn) return;
      var off = !srcBtn || srcBtn.hasAttribute('disabled');
      btn.disabled = off;
      if (btnLabel) btnLabel.textContent = off ? soldLabel : buyLabel;
      if (codBtn) codBtn.hidden = off;
    }

    syncPrice();
    syncState();

    // Dawn varyant değişiminde bu alanları yeniden yazıyor; kopyayı taze tut
    if ('MutationObserver' in window) {
      if (priceWrap) {
        new MutationObserver(syncPrice).observe(priceWrap, { childList: true, subtree: true });
      }
      new MutationObserver(syncState).observe(info, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    if (btn) {
      btn.addEventListener('click', function () {
        var target = info.querySelector('[name="add"]');
        if (target && !target.hasAttribute('disabled')) target.click();
      });
    }

    if (codBtn) {
      codBtn.addEventListener('click', function () {
        var cod = document.querySelector('[data-dv-cod]');
        if (cod) {
          cod.click();
          return;
        }
        info.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Ana satın alma alanı ekrandan çıkınca barı göster.
    // IntersectionObserver yerine kaydırmada ölçüyoruz: IO bazı ortamlarda
    // (ör. headless tarayıcı, programlı scroll) yeniden tetiklenmiyor.
    var anchor = info.querySelector('product-form') || srcBtn || info;
    var queued = false;

    function apply() {
      queued = false;
      var target = info.querySelector('product-form') || info.querySelector('[name="add"]') || anchor;
      var on = target.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('dv-sticky-on', on);
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(apply);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  /* ---------- 5. Yorumlar: daha fazla göster ----------------------------- */

  function initReviews() {
    var buttons = document.querySelectorAll('[data-dv-rev-more]');
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var grid = btn.closest('.dv-wrap') || document;
          var hidden = grid.querySelectorAll('[data-dv-rev-hidden]');
          for (var j = 0; j < hidden.length; j++) {
            hidden[j].hidden = false;
            hidden[j].removeAttribute('data-dv-rev-hidden');
          }
          btn.parentNode.removeChild(btn);
        });
      })(buttons[i]);
    }
  }

  /* ---------- 6. Fotoğraf büyütme ---------------------------------------- */

  function initLightbox() {
    var box = null;

    function close() {
      if (!box) return;
      box.classList.remove('is-on');
      var dead = box;
      box = null;
      window.setTimeout(function () {
        if (dead.parentNode) dead.parentNode.removeChild(dead);
      }, 220);
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    function open(src) {
      close();
      box = document.createElement('div');
      box.className = 'dv-lb';
      box.innerHTML =
        '<button type="button" class="dv-lb__x" aria-label="Kapat">&times;</button><img alt="">';
      box.querySelector('img').src = src;
      box.addEventListener('click', function (e) {
        if (e.target.tagName !== 'IMG') close();
      });
      document.body.appendChild(box);
      window.requestAnimationFrame(function () {
        if (box) box.classList.add('is-on');
      });
      document.addEventListener('keydown', onKey);
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-dv-lightbox]') : null;
      if (!t) return;
      e.preventDefault();
      open(t.getAttribute('data-dv-lightbox'));
    });
  }

  /* ---------- açılış ----------------------------------------------------- */

  function boot() {
    tick();
    window.setInterval(tick, 1000);
    window.addEventListener('scroll', paintBars, { passive: true });
    initSticky();
    initReviews();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
